import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { LoyaltyProvider } from "./context/LoyaltyContext";
import { Toaster } from "sonner";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <CartProvider>
      <LoyaltyProvider>
        <App />
        <Toaster position="top-center" richColors />
      </LoyaltyProvider>
    </CartProvider>
  </AuthProvider>
);
